import * as React from 'react';
export const KESvg = React.forwardRef(function KESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 11V5h1v6h-1ZM0 5h1v6H0V5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M1.505 2A1.5 1.5 0 0 0 0 3.5V5h16V3.5c0-.828-.667-1.5-1.505-1.5H1.505Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M0 11v1.5c0 .828.667 1.5 1.505 1.5h12.99A1.5 1.5 0 0 0 16 12.5V11H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        fillRule: 'nonzero',
        d: 'M10 5.764c.614.55 1 1.348 1 2.236 0 .888-.386 1.687-1 2.236C9.386 9.686 9 8.888 9 8c0-.888.386-1.687 1-2.236Zm-4 0c.614.55 1 1.348 1 2.236 0 .888-.386 1.687-1 2.236C5.386 9.686 5 8.888 5 8c0-.888.386-1.687 1-2.236Z',
      }),
    ),
  );
});
KESvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KE = {
  category: 'flag',
  colorable: false,
  name: 'KE',
  svg: KESvg,
};
